import styled from 'styled-components';

const SectionDivider = styled.div`
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    ${props => props.theme.colors.border} 50%,
    transparent 100%
  );
  margin: 4rem 0;
  opacity: 0.5;
`;

export default SectionDivider;